// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"516":"c66be54f","675":"b91302bb"}[chunkId] + ".chunk.js";
};